import * as req from 'api/actions';
import * as c from './constant';

const getTransactionCount = (
  payload = { module_type: 'EBPLS' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION_COUNTS,
    'api/temp/administrators/transaction_histories/business_permit',
    payload,
    callback
  );


export default getTransactionCount;